export default {
  state: {
    floors: [],
    currentFloor: 0,
    loading: false,
    error: null,
  },
  mutations: {
    SET_LOADING(state, isLoading) {
      state.loading = isLoading;
    },
    SET_FLOORS(state, floors) {
      state.floors = floors;
    },
    SET_CURRENT_FLOOR(state, floorNumber) {
      state.currentFloor = floorNumber;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    ADD_CAMERA_POINT(state, { floorNumber, cameraPoint }) {
      const floor = state.floors.find((f) => f.Number === floorNumber);
      if (floor) {
        if (!floor.CameraPoints) floor.CameraPoints = [];
        floor.CameraPoints.push(cameraPoint);
      }
    },
  },
  actions: {
    async fetchFloors({ commit }, url) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      try {
        const response = await url;

        const jsonDataResponse = await fetch(response.data.json.value);
        if (!jsonDataResponse.ok) {
          throw new Error(`Failed to fetch floor data: ${response.status} ${response.statusText}`);
        }

        const data = await jsonDataResponse.json();

        if (!Array.isArray(data.Floors)) {
          throw new Error('Invalid data format: Expected array of floors');
        }

        commit('SET_FLOORS', data.Floors);

        if (data.Floors.length > 0) {
          commit('SET_CURRENT_FLOOR', 0);
        }

        return data;
      } catch (error) {
        commit('SET_ERROR', error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    setCurrentFloor({ commit }, floorNumber) {
      commit('SET_CURRENT_FLOOR', floorNumber);
    },

    addCameraPoint({ commit }, payload) {
      commit('ADD_CAMERA_POINT', payload);
    },
  },
  getters: {
    allFloors: (state) => state.floors,
    currentFloor: (state) => state.currentFloor,
    floorByNumber: (state) => (number) => state.floors.find((f) => f.Number === number),
    roomsOnCurrentFloor: (state) => {
      if (!state.currentFloor) return [];
      return state.currentFloor.Units.flatMap((unit) => unit.Rooms);
    },
    isLoading: (state) => state.loading,
    error: (state) => state.error,
    totalFloors: (state) => state.floors.length,
    exteriorWalls: (state) => {
      if (!state.currentFloor) return [];
      return state.currentFloor.Walls.filter(
        (wall) => state.currentFloor.ExteriorWalls.includes(wall.ID),
      );
    },
  },
};
